import  {AfterContentInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Subscription } from 'rxjs';
import { ChatService } from 'src/app/services/chat.service';
import { Theme } from 'src/app/models/theme';
import { WebSocketService } from 'src/app/api/web-socket.service';

@Component({
    selector: 'trading-chart-page',
    templateUrl: './trading-chart-page.component.html',
    styleUrls: ['./trading-chart-page.component.scss'],
    standalone: false
})
export class TradingChartPageComponent implements OnInit, AfterContentInit, OnDestroy {
  static readonly QUERY_PARAM_PAIR = 'pair';
  static readonly QUERY_PARAM_THEME = 'theme';
  static readonly QUERY_PARAM_MOBILE = 'mobile';
  static readonly QUERY_PARAM_FULLSCREEN = 'fullScreen';

  static readonly DEFAULT_THEME = Theme.Light;
  static readonly DEFAULT_PAIR = 'BTC-AED';

  pair: string;
  mobile = false;
  fullscreen = false;
  theme: Theme = null;

  routeParamsSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private wss: WebSocketService,
    private chatService: ChatService,
    // TODO: remove after adding theme control
    @Inject(DOCUMENT) private docuemnt: Document,
  ) {}

  ngOnInit() {
    this.wss.connect();

    this.routeParamsSubscription = this.route.queryParamMap.subscribe((params) => {
      this.mobile = params.get(TradingChartPageComponent.QUERY_PARAM_MOBILE) === 'true';
      this.fullscreen = params.get(TradingChartPageComponent.QUERY_PARAM_FULLSCREEN) === 'true';
      const pair = params.get(TradingChartPageComponent.QUERY_PARAM_PAIR);
      const theme = params.get(TradingChartPageComponent.QUERY_PARAM_THEME);

      this.setPair(pair?.toUpperCase());
      this.setTheme(theme as Theme);
    });
  }

  ngAfterContentInit() {
    this.chatService.hide();
  }

  ngOnDestroy() {
    this.chatService.show();
    this.routeParamsSubscription?.unsubscribe();
    // TODO: remove after adding theme control
    // remove dark theme from body if it's applied
    this.clearThemeFromBody();
  }

  setPair(pair: string) {
    this.pair = pair ?? TradingChartPageComponent.DEFAULT_PAIR;
  }

  setTheme(theme: Theme) {
    this.theme = theme ?? TradingChartPageComponent.DEFAULT_THEME;
    this.clearThemeFromBody();
    this.addThemeToBody(this.theme);
  }

  addThemeToBody(theme: Theme) {
    this.docuemnt.body.classList.add(theme);
  }

  clearThemeFromBody() {
    this.docuemnt.body.classList.remove(Theme.Light);
    this.docuemnt.body.classList.remove(Theme.Dark);
  }
}
